import React from "react";
const NotFound = () => <h1>Page Not Found Page</h1>;
export default NotFound;
